import {
    MENS_MAGAZINE_CONFIRM_COMPONENT,
    MENS_MAGAZINE_LINKAGE_ID,
    MENS_MAGAZINE_PROFILE_COMPONENT,
    MENS_MAGAZINE_SITE_UNIQ_API_PATH, MENS_MAGAZINE_WITHDRAW_CUSTOM_COMPONENT,
    WEB_SPORTIVA_ACCEPT_CALLBACK_URLS,
    WEB_SPORTIVA_DEFAULT_CALLBACK_URL,
    WEB_SPORTIVA_EMAIL_DOMAINS, WEB_SPORTIVA_LINKAGE_NAME, WEB_SPORTIVA_LINKAGE_SUB_ID, WEB_SPORTIVA_MAGAZINE_PATH,
    WEB_SPORTIVA_SERVICE_TERM_URL
} from "@/commons/linkage/sites/webSportiva";
import { createLinkageRoute, linkageBeforeEach, linkageScrollBehavior } from "@/router/linkage";
import { createRouter, createWebHistory } from "vue-router";

// Sportiva画面用ルート定義
const routes = createLinkageRoute(
    MENS_MAGAZINE_LINKAGE_ID,
    WEB_SPORTIVA_LINKAGE_NAME,
    WEB_SPORTIVA_MAGAZINE_PATH,
    MENS_MAGAZINE_SITE_UNIQ_API_PATH,
    WEB_SPORTIVA_DEFAULT_CALLBACK_URL,
    WEB_SPORTIVA_ACCEPT_CALLBACK_URLS,
    WEB_SPORTIVA_SERVICE_TERM_URL,
    WEB_SPORTIVA_EMAIL_DOMAINS,
    MENS_MAGAZINE_PROFILE_COMPONENT,
    MENS_MAGAZINE_CONFIRM_COMPONENT,
    {
        linkageSubId: WEB_SPORTIVA_LINKAGE_SUB_ID,
        withDrawCustomComponent: MENS_MAGAZINE_WITHDRAW_CUSTOM_COMPONENT,
    }
);

// Sportiva画面用ルータ作成
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior: linkageScrollBehavior,
    routes: routes,
});

// beforeEach
router.beforeEach(linkageBeforeEach);

// Sportiva画面用ルータ
export const webSportivaRouter = router;
